export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              name: 'Div',
              attributes: { class: 'time-line-5' },
              components: [
                 {
                  type: 'itemTimeLine5', 
                  attributes: { class: 'item-time-line-5 margin-top-80 margin-top-sm-0'}
                 },
                 {
                    type: 'itemTimeLine5', 
                   },
                   {
                    type: 'itemTimeLine5', 
                    attributes: { class: 'item-time-line-5 margin-top-80 margin-top-sm-0'}
                   },
                   {
                    type: 'itemTimeLine5', 
                   },
                   {
                    type: 'itemTimeLine5', 
                    attributes: { class: 'item-time-line-5 margin-top-80 margin-top-sm-0'}
                   },
                   {
                    type: 'itemTimeLine5', 
                   },
                   {
                    type: 'itemTimeLine5', 
                    attributes: { class: 'item-time-line-5 margin-top-80 margin-top-sm-0'}
                   },
                   {
                    type: 'itemTimeLine5', 
                   },
                   {
                    type: 'itemTimeLine5', 
                    attributes: { class: 'item-time-line-5 margin-top-80 margin-top-sm-0'}
                   },
              ],
              styles: `
               .time-line-5{
                display:flex; 
                gap: 20px; 
                margin-top:50px;
                justify-content:center; 
               }
               .margin-top-80{
                margin-top: 80px; 
               }
               @media (max-width:992px){
                .time-line-5{
                  flex-wrap: wrap; 
                  gap: 16px;
                }
                .margin-top-sm-0{
                    margin-top: 0 !important
                }
               }
      
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};